import { FormikProps } from 'formik';
import { QuestionFormValues } from '@/utils/forms/questionTransformers';

interface QuestionImageFieldsProps {
  formik: FormikProps<QuestionFormValues>;
  isEditable: boolean;
  language?: 'en' | 'fr';
}

export function QuestionImageFields(_props: QuestionImageFieldsProps) {
  // Question Image URL field is not currently in use, so it's hidden from the form
  return null;
}
